/**
 * Error codes for Studiemeister - Courses API
 */
module.exports = {
  USER_NOT_ACTIVATED: 'E-STM-COU-NAUSR',
  USER_IS_NOT_STUDENT: 'E-STM-COU-NSUSR',
  COURSE_IS_NOT_PUBLISHED: 'E-STM-COU-NPUBC',
  STUDENT_HAS_ALREADY_PURCHASED_COURSE: 'E-STM-COU-SHAPC',
  COURSE_WITH_OLD_CONTENT: 'E-STM-COU-CWOC',
  COURSE_IS_ONLINE_BOOK: 'E-STM-COU-COB',
};
